import { logger, LogCategory } from './logger';

/**
 * Email attachment
 */
export interface EmailAttachment {
  filename: string;
  content: string;
  encoding: string;
  contentType: string;
}

/**
 * Email sending options
 */
export interface EmailSendOptions {
  to?: string;
  cc?: string;
  bcc?: string;
  subject: string;
  body: string;
  html?: string;
  attachments?: EmailAttachment[];
}

/**
 * Email sending response
 */
export interface EmailResponse {
  success: boolean;
  message: string;
  data?: any;
}

/**
 * Centralized service for sending emails
 */
export class EmailService {
  private apiUrl = 'https://ai-core.dev.azcld.advisori.de/fission/fraport/api/v1/email-service';
  
  /**
   * Send an email using the email service API
   */
  async sendEmail(options: EmailSendOptions): Promise<EmailResponse> {
    try {
      logger.info('Sending email', LogCategory.GENERAL, {
        to: options.to,
        subject: options.subject
      });
      
      const response = await fetch(this.apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(options)
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Failed to send email');
      }
      
      logger.info('Email sent successfully', LogCategory.GENERAL, {
        to: options.to,
        subject: options.subject
      });
      
      return {
        success: true,
        message: 'Email sent successfully!',
        data
      };
    } catch (error) {
      logger.error('Error sending email', LogCategory.GENERAL, {
        error,
        to: options.to,
        subject: options.subject
      });
      
      return {
        success: false,
        message: error instanceof Error ? error.message : 'An unknown error occurred'
      };
    }
  }
}

// Create a singleton instance
export const emailService = new EmailService();